import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import React, {useEffect, useRef, useState} from "react";
import '../../../css/web/BtorageGlobalModal.css'
import {useTranslation} from "react-i18next";
import commonClose from "../../../assets/img/commonClose.png";
import creditCard from "../../../assets/img/blueCard.png";
import MsgCheckModal from "./MsgCheckModal";
import axios from "axios";
import {refreshAccessToken} from "../../../services/axiosInstance";
import CardRefundPolicy from "./CardRefundPolicy";
import visa from "../../../assets/img/visa.png";
import master from "../../../assets/img/master.png";
import jcb from "../../../assets/img/jcb.png";
import amex from "../../../assets/img/amex.png";
import unionPay from "../../../assets/img/unionPay.png";
import {BiCaretDown} from "react-icons/bi";
import BtorageGlobalPasswordModal from "./BtorageGlobalPasswordModal";
import {initPayAttempt, notifyCancel, PAY_USAGE} from "../../../services/PayGuard";

function GlobalCardModal({
                             globalCardPopupSt,
                             closeGlobalCardPopup,
                             mbNum,
                             currency,
                             lastForPrice,
                             finalPayExpense,
                             afterOrderProcess,
                         usageType, // [결제누락 개선] 결제원장 용도
                         }) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const [payErrorMsg, setPayErrorMsg] = useState(false);
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';
    const modalWidth = platformType === '2' ? 350 : 400;

    const scrollViewRef = useRef(null);

    const [payBtLoading, setPayBtLoading] = useState(false);
    const [payBtDisabled, setPayBtDisabled] = useState(false);

    const closePayErrorMsg = () => {
        setPayErrorMsg(false);
    }

    const [payerMail, setPayerMail] = useState("");
    const findEmail = () => {
        axios({
            method: 'get',
            url: '/member/findEmail',
            params: {
                mbNum: mbNum,
            },
        })
            .then((response) => {
                setPayerMail(response.data);
            })
            .catch((error) => {
                console.log("이메일 조회오류 : ", error)
            });
    };

    useEffect(() => {
        if (mbNum) {
            findEmail();
        }
    }, [mbNum])

    // 카드환불규정
    const [cardPolicyAgree, setCardPolicyAgree] = useState(false);
    const [cardPolicyAgreeError, setCardPolicyAgreeError] = useState(false);
    const [isCardPoilicyPopup, setIsCardPoilicyPopup] = useState(false);
    const handleAgreeChange = () => {
        setCardPolicyAgree(prev => !prev);
    };
    const closeCardPolicyAgreeError = () => {
        setCardPolicyAgreeError(false);
    }
    const closeCardPolicyPopup = () => {
        setIsCardPoilicyPopup(false);
    }

    // 10자리 숫자생성기
    const generateState = () => {
        const today = new Date();
        const year = today.getFullYear().toString().slice(2); // 연도 마지막 2자리
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // 월 (2자리)
        const day = today.getDate().toString().padStart(2, '0'); // 일 (2자리)

        const dateString = `${year}${month}${day}`; // yyMMdd 형식
        const randomLong = Math.floor(Math.random() * 10_000); // 4자리 랜덤 숫자
        const randomNumber = randomLong.toString().padStart(10, '0');
        return dateString + randomNumber;
    }

    const [popupBlock, setPopupBlock] = useState(false);
    const closePopupBlock = () => {
        setPopupBlock(false);
    }

    const payWinRef = useRef(null);
    const pollingWorkerRef = useRef(null);
    const popupCheckIntervalRef = useRef(null);

    // ══════════════════════════════════════════════════════════════════════════════
    // [결제누락 개선]
    //  1) payNumRef : 실제 결제식별번호(payNum)를 보관하여 afterOrderProcess 로 전달한다.
    //     (기존에는 상수문자열을 넘겨 PG 결제건과 주문서를 연결할 수 없었다)
    //  2) 유예폴링 : 결제팝업이 닫혀도 즉시 폴링을 종료하지 않고 아래 시간동안 결제성공 여부를 계속 확인한다.
    //     (기존에는 즉시 terminate() 하여 결제완료 직후 팝업을 닫으면 주문서가 저장되지 않는 누락이 발생)
    // ══════════════════════════════════════════════════════════════════════════════
    const payNumRef = useRef(null);
    const graceTimeoutRef = useRef(null);
    const PAY_POLLING_GRACE_MS = 90000; // 팝업 닫힘 후 결제확인 유예시간 (90초)

    /** 폴링/타이머 일괄 정리 */
    const clearPayWatchers = () => {
        if (popupCheckIntervalRef.current) {
            clearInterval(popupCheckIntervalRef.current);
            popupCheckIntervalRef.current = null;
        }
        if (graceTimeoutRef.current) {
            clearTimeout(graceTimeoutRef.current);
            graceTimeoutRef.current = null;
        }
        if (pollingWorkerRef.current) {
            pollingWorkerRef.current.terminate();
            pollingWorkerRef.current = null;
        }
    };

    // 컴포넌트 언마운트 시 폴링 워커가 남지 않도록 정리
    useEffect(() => {
        return () => clearPayWatchers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const payment = async () => {
        setPayBtDisabled(true);
        setPayBtLoading(true);

        if (!cardPolicyAgree) {
            setCardPolicyAgreeError(true);
            setPayBtDisabled(false);
            setPayBtLoading(false);
            return;
        }

        try {
            const btoragePayNum = generateState();
            payNumRef.current = btoragePayNum;

            // [결제누락 개선] 결제팝업을 열기 전에 결제원장을 선기록한다.
            //  이후 페이레터 noti 에서 서버가 이 원장을 PAID 로 확정하므로,
            //  주문서 저장이 실패하더라도 '결제됨/주문없음' 누락건을 반드시 탐지할 수 있다.
            await initPayAttempt({
                payNum: btoragePayNum,
                payWay: 'PM08',
                usageType: usageType || PAY_USAGE.ORDER,
                amount: finalPayExpense,
                forAmount: lastForPrice,
                forCurrency: currency,
            });

            const isMobile = platformType === '2';
            const popupWidth = 800;
            const popupHeight = 500;

            // PC 사이즈 설정
            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
            const left = dualScreenLeft + (windowWidth - popupWidth) / 2;
            const top = dualScreenTop + (windowHeight - popupHeight) / 2;

            const windowFeatures = isMobile ? '' : `width=${popupWidth},height=${popupHeight},left=${left},top=${top},resizable=yes,scrollbars=yes`;
            // 브라우저별 팝업정책으로 미리 빈창 열기
            let payWin = window.open('', 'PayletterPay', windowFeatures);
            payWinRef.current = payWin;

            // recurringType=N -> notiurl로 콜백
            const notiurl = `https://btorage.com/api/btoragePay/saveOsTempPayNum?mbNum=${mbNum}&payNum=${btoragePayNum}&cardPgInfo=${selectedPgInfo}&type=0`;
            const returnurl = `https://btorage.com/api/btoragePay/PaymentLoading`;

            // 엔화만 소숫점 2자리 수 제거
            const convertToPrice =
                currency === "JPY"
                    ? String(lastForPrice).includes('.')
                        ? String(lastForPrice).split('.')[0]  // 소수점 앞부분만
                        : lastForPrice  // 이미 정수라면 그대로
                    : lastForPrice;

            const res = await axios.post('/btoragePay/osPayOpenWindow', {
                currency: currency,
                payNum: btoragePayNum,
                amount: convertToPrice,
                payerid: payerMail,
                payeremail: payerMail,
                returnurl: returnurl,
                notiurl: notiurl,
                pginfo: selectedPgInfo,
                recurringtype: "N",
            }, );

            console.log("payWin : ", payWin)
            console.log("응답값 : ", res?.data)

            // 팝업 && 데이터 보장
            if (payWin && res?.data) {
                console.log("Pop-up open")
                // ✅ polling 시작 (Web Worker 방식)
                startPollingWithWorker(mbNum, btoragePayNum, LCAT || SSAT);
                payWin.location.href = platformType === '2' ? res.data.mobile_url : res.data.online_url;
            } else {
                setPopupBlock(true);
                setPayBtDisabled(false);
                setPayBtLoading(false);
                return;
            }

            // 팝업 닫힘 감지
            popupCheckIntervalRef.current = setInterval(() => {
                if (payWinRef.current && payWinRef.current.closed) {
                    setPayBtDisabled(false);
                    setPayBtLoading(false);
                    clearInterval(popupCheckIntervalRef.current);
                    popupCheckIntervalRef.current = null;

                    // [결제누락 개선] 팝업이 닫혀도 폴링을 즉시 종료하지 않고 유예시간동안 결제성공 여부를 계속 확인한다.
                    if (pollingWorkerRef.current && !graceTimeoutRef.current) {
                        graceTimeoutRef.current = setTimeout(() => {
                            if (pollingWorkerRef.current) {
                                pollingWorkerRef.current.terminate();
                                pollingWorkerRef.current = null;
                                notifyCancel({
                                    payNum: payNumRef.current,
                                    failReason: 'Payment popup closed and not confirmed within grace period',
                                });
                            }
                            graceTimeoutRef.current = null;
                        }, PAY_POLLING_GRACE_MS);
                    }
                }
            }, 500);

        } catch (err) {
            setPayErrorMsg(true);
            setPayBtDisabled(false);
            setPayBtLoading(false);
        }
    }

    // ✅ polling 전용 함수 (Web Worker 생성)
    /** 폴링 중 토큰만료로 재발급을 시도한 마지막 시각 (2초 폴링마다 두드리지 않도록 조절) */
    const lastTokenRenewRef = useRef(0);

    const startPollingWithWorker = (mbNum, payNum, token) => {
        if (pollingWorkerRef.current) {
            pollingWorkerRef.current.terminate();
        }

        const workerCode = () => {
            let timer = null;
            let authToken = null;

            // eslint-disable-next-line no-restricted-globals
            self.onmessage = async function (e) {
                /*
                 * [토큰교체 메시지] 메인스레드가 갱신된 액세스토큰을 보내온 경우.
                 *  토큰만 바꿔 끼우고 즉시 끝낸다. 여기서 빠져나가지 않으면 아래
                 *  setInterval 이 하나 더 생겨 폴링이 중복 실행된다.
                 */
                if (e.data && e.data.type === 'TOKEN') {
                    if (e.data.token) authToken = e.data.token;
                    return;
                }

                const { mbNum, payNum, token, url } = e.data;
                authToken = token;

                const poll = async () => {
                    try {
                        const res = await fetch(`${url}?payNum=${payNum}&type=0`, {
                            method: 'POST',
                            headers: {
                                Authorization: authToken,
                            },
                        });
                        /*
                         * [중요] 401 은 '액세스토큰이 만료됐다' 는 뜻이다.
                         *  워커는 시작할 때 받은 토큰을 그대로 들고 있으므로, 여기서
                         *  그냥 넘기면 같은 토큰으로 영원히 401 만 받으며 결제완료를
                         *  끝까지 감지하지 못한다 (= 결제누락).
                         *  메인스레드에 새 토큰을 요청하고, 폴링은 멈추지 않는다.
                         */
                        if (res.status === 401) {
                            // eslint-disable-next-line no-restricted-globals
                            self.postMessage({ status: 'TOKEN_EXPIRED' });
                            return;
                        }
                        if (!res.ok) {
                            throw new Error(`웹 워커 poll.res 응답에러 : ${res.status}`);
                        }
                        const data = await res.json();
                        if (data) {
                            clearInterval(timer);
                            // eslint-disable-next-line no-restricted-globals
                            self.postMessage({ status: 'COMPLETED' });
                        }
                    } catch (err) {
                        console.error('Polling error:', err);
                        // eslint-disable-next-line no-restricted-globals
                        self.postMessage({ status: 'ERROR', error: err.message });
                        // 통신 오류 시에도 무시하고 polling 지속
                    }
                };

                // [결제누락 개선] 폴링 주기 5초 -> 2초 (결제성공 감지 지연으로 인한 누락 최소화)
                await poll();
                timer = setInterval(poll, 2000);
            };
        };

        const blob = new Blob(['(' + workerCode.toString() + ')()'], { type: 'application/javascript' });
        const worker = new Worker(URL.createObjectURL(blob));
        pollingWorkerRef.current = worker;

        const fullUrl = new URL('/api/btoragePay/selectedTempPayNum', window.location.origin).href;
        worker.postMessage({ mbNum, payNum, token, url: fullUrl });

        worker.onmessage = function (e) {
            if (e.data.status === 'COMPLETED') {
                setPayBtDisabled(false);
                setPayBtLoading(false);
                if (payWinRef.current && !payWinRef.current.closed) {
                    payWinRef.current.close();
                }
                clearPayWatchers();
                // [결제누락 개선] 상수문자열이 아닌 실제 결제식별번호(payNum)를 전달하여 주문서에 저장되도록 한다.
                afterOrderProcess("COMPLETED", payNumRef.current || payNum, "globalCard");
            } else if (e.data.status === 'TOKEN_EXPIRED') {
                /*
                 * 폴링 중 액세스토큰이 만료됐다. 조용히 갱신해서 워커에 새 토큰을 넘긴다.
                 *  갱신이 실패해도 폴링은 계속 돌고 있으므로, 30초에 한 번만 시도해
                 *  (폴링주기 2초마다 재발급을 두드리는 것을 막는다) 서버 부담을 피한다.
                 */
                const now = Date.now();
                if (now - lastTokenRenewRef.current >= 30000) {
                    lastTokenRenewRef.current = now;
                    refreshAccessToken().then((fresh) => {
                        if (fresh && pollingWorkerRef.current) {
                            pollingWorkerRef.current.postMessage({ type: 'TOKEN', token: fresh });
                        }
                    });
                }
            } else if (e.data.status === 'ERROR') {
                console.error('Error from polling worker:', e.data.error);
            }
        };
    };

    // 여기서부터 카드사별 pginfo 분류 라디오박스
    const CARD_TYPES = [
        {
            value: "PLCreditCardMpi",
            key: "VISA",
            logos: [visa, master, jcb]
        },
        {
            value: "PLCreditCard",
            key: "AMEX",
            logos: [amex]
        },
        {
            value: "PLUnionPay",
            key: "UNION",
            logos: [unionPay]
        }
    ];

    // Amex, UnionPay는 USD만 표시
    const shownCards = CARD_TYPES.filter(card =>
        card.key === "VISA" || currency === "USD"
    );

    const [selectedPgInfo, setSelectedPgInfo] = useState("PLCreditCardMpi");
    const [selectedKey, setSelectedKey] = useState("VISA");






    return (
        <div className="btorage-pay-modal-container md-scope" data-theme={theme}>
            <div className="btorage-pay-modal-frame" style={{width: `${modalWidth}px`}}>
                <div className="btorage-pay-modal-scroll-area p-r-10" ref={scrollViewRef}>
                    <div className="font-t-cont">
                        {/*헤더*/}
                        <div className="display-flex just-cont-fend m-b-20">
                            <img onClick={closeGlobalCardPopup} className="c-point wd-30 ht-30 m-a-opc-06"
                                 src={commonClose}
                                 alt="close"/>
                        </div>
                        {/*바디*/}
                        <div className="btorage-pay-modal-body-container">
                            <div className="btorage-pay-modal-header-container">
                                <div className="btorage-pay-modal-header-frame">
                                    <p className="btorage-pay-modal-header-text">{t(`modHeader10`)}</p>
                                </div>
                                <div>
                                    <img src={creditCard} className="wd-40 ht-40" alt="btoragePay"/>
                                </div>
                            </div>

                            <div className="btorage-pay-modal-price-container">
                                <div className="btorage-pay-modal-price-frame">
                                    <a className="btorage-pay-modal-price-text1">{t(`pcWon`)}</a>
                                    <a className="btorage-pay-modal-price-text2">{finalPayExpense && finalPayExpense.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                </div>
                                <div className="btorage-pay-modal-price-frame">
                                    <a className="btorage-pay-modal-price-text1">{t(`modExr`)}</a>
                                    <div>
                                        <a className="btorage-pay-modal-price-text2">{lastForPrice && lastForPrice}</a>
                                        <a className="m-l-3 font-s-12 btorage-pay-modal-price-text1">{currency && currency}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    {/*푸터*/}
                    <div className="font-t-cont">

                        {/*카드환불규정*/}
                        <div className="display-flex align-center">
                            <div className="wd-100pc display-flex align-center min-ht-30 m-t-10"
                                 style={{backgroundColor: "#FFF3F1", borderRadius: "6px", padding: "0 10px"}}>
                                <div className="display-flex align-center">
                                    <input
                                        id="cardPolicyAgree"
                                        type="checkbox"
                                        className="wd-15 ht-15 c-point"
                                        checked={cardPolicyAgree}
                                        onChange={handleAgreeChange}
                                    />
                                </div>
                                <div className="wd-100pc display-flex align-center justify-content-between"
                                     style={{padding: "0 10px"}}>
                                    <div className="border-rd6" style={{backgroundColor: "#FFF3F1"}}>
                                        <label className="font-s-13 c-point" htmlFor="cardPolicyAgree"><span
                                            style={{color: "#FF7962"}}>{t('bpmTx20')}</span>
                                        </label>
                                    </div>
                                    <div onClick={() => setIsCardPoilicyPopup(true)}>
                                        <a className="font-s-12 c-point" style={{color: "#FF7962"}}>{t('bpmTx21')}</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { currency === "USD" ?
                        <div className="display-flex flex-row justify-content-between align-items-center m-t-30">
                            <a className="font-s-13">※ {t('bpmTx31')}</a>
                            {/*<div className="user-center gap4">*/}
                            {/*    <img alt="visa" className="wd-25 ht-20 gap3" src={visa}/>*/}
                            {/*    <img alt="master" className="wd-25 ht-20 gap3" src={master}/>*/}
                            {/*    <img alt="jcb" className="wd-25 ht-16 gap3" src={jcb}/>*/}
                            {/*    {currency === "USD" &&*/}
                            {/*        <div className="user-center">*/}
                            {/*            <img alt="amex" className="wd-25 ht-18 gap3" src={amex}/>*/}
                            {/*            <img alt="unionPay" className="wd-25 ht-20 gap3" src={unionPay}/>*/}
                            {/*        </div>*/}
                            {/*    }*/}
                            {/*</div>*/}
                        </div> :
                            <div className="display-flex flex-row justify-content-between align-items-center m-t-30"></div>
                            }

                        {/*카드사선택*/}
                        <div className="display-flex gap5 wd-100pc just-cont-center align-items-center" style={{margin: "10px 0"}}>
                            {shownCards.map(card => (
                                <label
                                    key={card.key}
                                    className="border-rd6 display-flex align-items-center just-cont-center wd-100pc c-point"
                                    style={{
                                        border: "1px solid #EAEAEA",
                                        padding: "8px",
                                    }}>
                                    <input
                                        type="radio"
                                        name="card-company"
                                        checked={selectedKey === card.key}
                                        onChange={() => {
                                            setSelectedPgInfo(card.value);
                                            setSelectedKey(card.key);
                                        }}
                                        style={{display: "none"}}/>
                                    <span
                                        className="wd-16 ht-16 user-center m-r-8 position-relative bt-background-fff"
                                        style={{
                                            border: selectedKey === card.key ? "2px solid #FFBE48" : "2px solid #EAEAEA",
                                            borderRadius: "50%",
                                        }}>
                                        {selectedKey === card.key && (
                                            <span
                                                className="ht-8 position-absolute"
                                                style={{
                                                    width: 8,
                                                    borderRadius: "50%",
                                                    background: "#FFBE48",
                                                    left: 2,
                                                    top: 2}}>
                                            </span>
                                        )}
                                    </span>

                                    <span style={{display: "flex", marginLeft:'-5px'}}>
                                        {card.logos.map((logo, idx) => (
                                            <img src={logo} key={idx} alt=""
                                                 className="wd-30 ht-20 object-fit-contain bt-background-fff"/>
                                        ))}
                                    </span>
                                </label>
                            ))}
                        </div>

                        {/*푸터*/}
                        <div className="user-center m-t-10 m-b-50">
                            <style>
                                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                            </style>
                            <button onClick={payment} disabled={payBtDisabled}
                                    className="orderItemHandleBt wd-100pc ht-40 font-s-14 border-rd4 user-center">
                                {payBtLoading ? (
                                    <div className="spinner"></div>
                                ) : (
                                    "Payment"
                                )}
                            </button>
                        </div>


                    </div>

                </div>
            </div>



            {payErrorMsg ?
                <MsgCheckModal payErrorMsg={payErrorMsg} closePayErrorMsg={closePayErrorMsg}/>
                :
                cardPolicyAgreeError ?
                    <MsgCheckModal cardPolicyAgreeError={cardPolicyAgreeError}
                                   closeCardPolicyAgreeError={closeCardPolicyAgreeError}/>
                    :
                    popupBlock ?
                        <MsgCheckModal popupBlock={popupBlock}
                                       closePopupBlock={closePopupBlock}/>
                        :
                            isCardPoilicyPopup ?
                                <CardRefundPolicy closeCardPolicyPopup={closeCardPolicyPopup}/>
                                :
                                null
            }


        </div>
    )
}

export default GlobalCardModal
